module.exports = __webpack_public_path__ + "static/media/location_ruka.42cda559.jpg";